import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class BottomDrawerService {
  addNoteOpenedState = new Subject<boolean>();

  constructor() {}
}
